import { useCallback } from 'react';
import useSWR from 'swr';
import { CACHE_KEYS } from '../utils/CacheUtils.js';
/**
 * @param client
 * @param query If `undefined`, no data is fetched
 * @param paging
 * @returns If no result, `connection` is `undefined`. If there are no matches, `connection` is `null`
 */
export function useAdminEntities(client, query, paging) {
    const fetcher = useCallback(([_action, query, paging]) => fetchGetEntities(client, query, paging), [client]);
    const { data, error } = useSWR(query ? CACHE_KEYS.adminEntities(query, paging) : null, fetcher);
    // useDebugLogChangedValues('useAdminEntities updated values', {
    //   client,
    //   query,
    //   paging,
    //   data,
    //   error,
    // });
    return { connection: data, connectionError: error };
}
async function fetchGetEntities(client, query, paging) {
    const result = await client.getEntities(query, paging);
    if (result.isError()) {
        throw result; // throw result, don't convert to Error
    }
    return result.value;
}
//# sourceMappingURL=useAdminEntities.js.map